import { Navigate, useLocation } from "react-router-dom";
import { CircleNotch } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import PendingApproval from "./PendingApproval";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <CircleNotch className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (user.approval && user.approval !== "approved") return <PendingApproval />;
  return children;
}
